import { client } from '@api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  SET_PROMO_CODE_TO_CART_MUTATION, SetPromoCodesToCartVariables, SetPromoCodesToCartResponse,
  GetCartDiscountsResponse, GET_CART_DISCOUNTS_QUERY,
} from '@requests/cart';
import { ViaxOrder } from '@types';

interface RemovePromotionFromCartProps {
  cartId: string;
}

type RemovePromotionFromCartResult = { wSetPromoCodes: ViaxOrder } & GetCartDiscountsResponse;

export const removePromotionFromCart = createAsyncThunk<RemovePromotionFromCartResult, RemovePromotionFromCartProps>(
  'cart/removePromotionFromCart',
  async ({ cartId }, { rejectWithValue }) => {
    try {
      const variables: SetPromoCodesToCartVariables = {
        orderUid: cartId,
        promoCodes: [],
      };
      const updatedCart = await client.request<SetPromoCodesToCartResponse>(SET_PROMO_CODE_TO_CART_MUTATION, variables);

      if (updatedCart.wSetPromoCodes.result.status !== 'OK') {
        return rejectWithValue(cartId);
      }

      const cartDiscounts = await client.request<GetCartDiscountsResponse>(GET_CART_DISCOUNTS_QUERY, { uid: cartId });

      return { wSetPromoCodes: updatedCart.wSetPromoCodes.result.data, ...cartDiscounts };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return rejectWithValue(cartId);
    }
  },
);
